var map = {
	"./benefits.png": 5304,
	"./businessplan.png": 1540,
	"./companyaim.png": 3100,
	"./customervalidation.png": 6956,
	"./projectmanagement.png": 6436,
	"./subject.png": 3535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8340;